import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconTSM.svg";

export const TSMSvg = styled(svg)`
    background-color: #449DF7;
    padding: 6px;
    overflow: visible;
    border-radius: 50%;
    fill: white;

`;
